import React, { useEffect, useState } from "react";
import { DateRangeSelector } from "./components/DateRangeSelector";
import OrdersByCommissionPartnersChart from "./components/charts/OrdersByCommissionPartnersChart";
import MonthlyRevenueChart from "./components/charts/MonthlyRevenueChart";
import VehiclePerformanceChart from "./components/charts/VehiclePerformanceChart";
import DriverAvailabilityChart from "./components/charts/DriverAvailabilityChart";
import DriverAssignedOrdersChart from "./components/charts/DriverAssignedOrdersChart";
import DriverCompletedOrdersChart from "./components/charts/DriverCompletedOrdersChart";
import { useLocation } from "react-router-dom";
import { ChartArea, Table } from "lucide-react";
import TaxiReportData from "@/taxi-dispatch/reports/TaxiReportData";
import { Tabs, TabsTrigger, TabsList, TabsContent } from "@/components/ui/tabs";

const Reports: React.FC = () => {
  const { state } = useLocation();
  const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  useEffect(() => {
    if (!state) return;
    if (state.startDate) {
      const { startDate } = state;
      setRange((prev) => {
        return {
          ...prev,
          startDate,
        };
      });
    }
  }, [state]);

  return (
    <div>
      <Tabs defaultValue="chart">
        <TabsList className="mx-5 mt-5">
          <TabsTrigger value="chart" title="Chart">
            <ChartArea />
          </TabsTrigger>
          <TabsTrigger value="table" title="Table">
            <Table />
          </TabsTrigger>
        </TabsList>
        <TabsContent value="chart" className="px-5">
          <div>
            <DateRangeSelector range={range} setRange={setRange} />
            <div className="@container/main flex flex-1 flex-col gap-2">
              <div className="flex flex-col gap-4">
                <div className="*:data-[slot=card]:shadow-xs @xl/main:grid-cols-2 @5xl/main:grid-cols-4 grid grid-cols-1 gap-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card">
                  <OrdersByCommissionPartnersChart range={range} />
                  <MonthlyRevenueChart range={range} />
                </div>
                <div className="*:data-[slot=card]:shadow-xs @xl/main:grid-cols-2 @5xl/main:grid-cols-4 grid grid-cols-1 gap-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card">
                  <VehiclePerformanceChart range={range} />
                  <DriverAvailabilityChart range={range} />
                  <DriverAssignedOrdersChart range={range} />
                  <DriverCompletedOrdersChart range={range} />
                </div>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="table" className="-mt-5">
          <TaxiReportData />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Reports;
